import Popup from './popup';
import './popup.scss';

export default Popup;
